import { Instagram, Linkedin, Mail } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import img1 from "../../Assets/image/image (1).webp";
import img2 from "../../Assets/image/clutch.webp";
import img3 from "../../Assets/image/research-partner-badge.svg";
import img4 from "../../Assets/image/image (4).webp";
import img5 from "../../Assets/image/image (3).webp";
import { SubTab, Tab, footerTabs } from "./tabs-data/tabs-data";

function Footer() {
  const navigate = useNavigate();
  const year = new Date();

  const logos = [
    { img: img1, url: "https://softcodingsolutions.com/" },
    {
      img: img2,
      url: "https://clutch.co/profile/softcoding-solutions?_gl=1*15eqwr6*_gcl_au*MzE0NjAzNzAxLjE3NDA5ODU4Nzg.*_ga*MTMwMjY3NTkwMi4xNzQwOTg1ODc4*_ga_D0WFGX8X3V*MTc0MDk4NTg3Ny4xLjAuMTc0MDk4NTg4NS41Mi4wLjEzMDY0NTk5MzQ.#reviews",
    },
    {
      img: img3,
      url: "https://www.goodfirms.co/resources/why-apps-ask-permissions-know-data-control",
    },
    {
      img: img5,
      url: "https://www.goodfirms.co/",
    },
    { img: img4, url: "https://businessfirms.co/company/softcoding-solutions" },
  ];

  const handleTabClick = (tab: Tab | SubTab) => {
    if (tab.path) {
      navigate(tab.path);
    } else if ("product_id" in tab && tab.product_id) {
      navigate(`/product/${tab.name}/${tab.product_id}`);
    }
  };

  return (
    <footer className="w-full border-t relative overflow-hidden text-[#e2e8f0]">
      <div className="flex justify-center items-center gap-2 md:gap-8 w-full py-3 ">
        {logos.map((data, index) => (
          <Link to={data.url} target="_blank" key={index}>
            <img
              src={data.img}
              alt="Logo"
              className="object-contain h-32 w-32 bg-white"
            />
          </Link>
        ))}
      </div>
      <div className="w-full relative">
        <div className="w-full h-full bg-gradient-to-bl from-primary via-primary/80 to-primary/40 absolute -z-10" />
        <div className="max-w-[1400px] mx-auto px-6 py-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 relative">
          {footerTabs.map((tab) => (
            <div key={tab.id}>
              <h3 className="font-bold uppercase text-lg text-gray-200">
                {tab.name}
              </h3>
              <ul className="space-y-2 mt-2">
                {tab.subTabs?.map((subTab) => (
                  <li onClick={() => handleTabClick(subTab)} key={subTab.id}>
                    <div className="text-[#161616] hover:text-gray-200 transition duration-300 cursor-pointer font-medium">
                      {subTab.name}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h3 className="font-bold text-lg text-gray-200">FOLLOW US</h3>
            <ul className="flex space-x-4 mt-2">
              <li>
                <Link
                  to="https://www.instagram.com/softcodingsolution?igsh=MTYwNHduYnl1ZGZ0"
                  target="_blank"
                  className="text-[#161616] hover:text-gray-200"
                >
                  <Instagram size={20} />
                </Link>
              </li>
              <li>
                <Link
                  to="https://www.linkedin.com/company/softcoding-solutions/"
                  target="_blank"
                  className="text-[#161616] hover:text-gray-200"
                >
                  <Linkedin size={20} />
                </Link>
              </li>
            </ul>
            <div className="flex flex-col gap-3 mt-4">
              <h3 className="font-bold text-lg text-gray-200 flex gap-2 items-center">
                <Mail size={20} /> EMAIL
              </h3>
              <p className="text-[#161616] hover:text-gray-200 font-medium text-xs md:text-base flex items-center gap-2">
                Sales: <span>sales@softcodingsolutions.com</span>
              </p>
              <p className="text-[#161616] hover:text-gray-200 font-medium text-xs md:text-base flex items-center gap-2">
                General: <span>support@softcodingsolutions.com</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0 text-center md:text-left">
          <div className="space-y-2">
            <p className="text-sm font-semibold text-[#161616]">
              &copy;{year.getFullYear()} Softcoding Solutions. All rights
              reserved.
            </p>
            <p className="text-sm text-[#161616] max-w-md">
              Softcoding Solutions is an IT company dedicated to empowering
              businesses with innovative technology.
            </p>
          </div>

          <div className="flex space-x-4">
            <Link to="#" className="text-sm text-[#161616] hover:underline">
              Terms
            </Link>
            <Link to="#" className="text-sm text-[#161616] hover:underline">
              Privacy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
